import { useField } from 'formik';
import { DetailedHTMLProps, FC, InputHTMLAttributes } from 'react';
import { Input } from '.';

type InputWithFormikProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  name: string;
  onResetCallback?: () => void;
};

export const InputWithFormik: FC<Omit<InputWithFormikProps, 'onChange' | 'value'>> = ({
  name,
  onResetCallback,
  ...rest
}) => {
  const [field, d, w] = useField({ name });
  return <Input {...rest} {...field} onResetInput={onResetCallback} />;
};
